// Check if type is group
export const isGroup = (option) => {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    return option.options !== undefined;
};
